/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type VasServiceTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const VasServiceTypeEnum = {
    NUMBER_1: 1 as VasServiceTypeEnum,
    NUMBER_2: 2 as VasServiceTypeEnum,
    NUMBER_3: 3 as VasServiceTypeEnum,
    NUMBER_4: 4 as VasServiceTypeEnum,
    NUMBER_5: 5 as VasServiceTypeEnum,
    NUMBER_6: 6 as VasServiceTypeEnum,
    NUMBER_7: 7 as VasServiceTypeEnum
};
